import React, { Component } from "react";
import axios from "axios";

let url_arr = [];

class ConversationForm extends Component {
  constructor(props) {
    super(props);
    this.cf = null;
    this.state = {
      name: "",
      email: "",
      access_token: "",
      urls: [],
      mention_name: "",
      user_url: ""
    };
  }

  // Validation URL
  validateUrl(url) {
    let re = /https:\/\/github\.com\/.+\/pull\/\d+/;
    return re.test(url);
  }

  // Get data to server
  async postData() {
    for (let index = 0; index < this.state.urls.length; index++) {
      await axios.post(`https://opensource.softagram.com/api/demo`, {
        access_token: this.state.access_token,
        PR_address: this.state.urls[index],
        mention_name: this.state.mention_name,
        user_url: this.state.user_url,
        email: this.state.email
      });
    }
  }

  // get user info at Github
  getInfoUser() {
    // Get access_token from server
    let getToken = () => {
      return axios
        .post(
          `https://opensource.softagram.com/api/oauth-tokens/github-oss-demo`,
          {
            code: this.props.code
          },
          {
            headers: {
              Accept: "application/json"
            }
          }
        )
        .then(response => response.data.access_token);
    };

    getToken().then(token => {
      this.setState({ access_token: token });
      axios
        .get(`https://api.github.com/user`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        })
        .then(user =>
          this.setState(
            {
              name: user.data.name,
              email: user.data.email,
              mention_name: user.data.login,
              user_url: user.data.html_url
            },
            () => {
              window.ConversationalForm.addRobotChatResponse(
                "Thanks <b>" +
                  this.state.name +
                  "</b><br>&&" +
                  "Softagram report appears here:"
              );
              switch (this.state.urls.length) {
                case 1:
                  window.ConversationalForm.addRobotChatResponse(
                    "<b>" + this.state.urls[0] + "</b>"
                  );
                  break;
                case 2:
                  window.ConversationalForm.addRobotChatResponse(
                    "<b>" +
                      this.state.urls[0] +
                      "</b>&&" +
                      "<b>" +
                      this.state.urls[1] +
                      "</b>"
                  );
                  break;
                case 3:
                  window.ConversationalForm.addRobotChatResponse(
                    "<b>" +
                      this.state.urls[0] +
                      "</b>&&" +
                      "<b>" +
                      this.state.urls[1] +
                      "</b>&&" +
                      this.state.urls[2] +
                      "</b>"
                  );
                  break;
                case 4:
                  window.ConversationalForm.addRobotChatResponse(
                    "<b>" +
                      this.state.urls[0] +
                      "</b>&&" +
                      "<b>" +
                      this.state.urls[1] +
                      "</b>&&" +
                      "<b>" +
                      this.state.urls[2] +
                      "</b>&&" +
                      "<b>" +
                      this.state.urls[3] +
                      "</b>"
                  );
                  break;
                case 5:
                  window.ConversationalForm.addRobotChatResponse(
                    "<b>" +
                      this.state.urls[0] +
                      "</b>&&" +
                      "<b>" +
                      this.state.urls[1] +
                      "</b>&&" +
                      "<b>" +
                      this.state.urls[2] +
                      "</b>&&" +
                      "<b>" +
                      this.state.urls[3] +
                      "</b>&&" +
                      "<b>" +
                      this.state.urls[4] +
                      "</b>"
                  );
                  break;
                default:
              }
              window.ConversationalForm.addRobotChatResponse(
                "we'll deliver the report(s) asap.&&" +
                  "If you have the usual notification settings in GitHub," +
                  "you'll receive an email as we mention your username in the report.&&" +
                  "Thanks for using our service! 💖"
              );
              this.postData();
            }
          )
        );
    });
  }

  componentDidMount() {
    // add Conversational Form info
    this.cf = window.cf.ConversationalForm.startTheConversation({
      formEl: this.refs.form,
      context: document.getElementById("cf-context"),
      flowStepCallback: (dto, success, error) => {
        let name = dto.tag.name;
        let value = dto.tag.value;

        for (let count = 0; count <= 5; count++) {
          if (name === "url" + count) {
            if (this.validateUrl(value)) {
              if (url_arr.includes(value)) {
                return error();
              } else url_arr.push(value);
              this.setState({
                urls: url_arr
              });
              return success();
            } else {
              return error();
            }
          }
        }
        return success();
      },
      robotImage:
        "https://softagram.com/wp-content/uploads/2018/12/apple-icon.png",
      userImage: "https://softagram.com/wp-content/uploads/2018/12/user.jpeg",
      submitCallback: () => {
        // Get user information and display
        this.getInfoUser();
      },
      userInterfaceOptions: {
        controlElementsInAnimationDelay: 500,
        robot: {
          robotResponseTime: 800,
          chainedResponseTime: 1000
        },
        user: {
          showThinking: true,
          showThumb: true
        }
      }
    });
  }

  render() {
    return (
      <div id="cf-context">
        <div id="form" className="form" ref="form">
          <fieldset cf-questions="How many pull requests are you going to give (max 5)?">
            <label htmlFor="intro-1">
              1
              <input type="radio" name="cfc-intro" id="intro-1" value="1" />
            </label>
            <label htmlFor="intro-2">
              2
              <input type="radio" name="cfc-intro" id="intro-2" value="2" />
            </label>
            <label htmlFor="intro-3">
              3
              <input type="radio" name="cfc-intro" id="intro-3" value="3" />
            </label>
            <label htmlFor="intro-4">
              4
              <input type="radio" name="cfc-intro" id="intro-4" value="4" />
            </label>
            <label htmlFor="intro-5">
              5
              <input type="radio" name="cfc-intro" id="intro-5" value="5" />
            </label>
          </fieldset>
          {/* 1 PR */}
          <input
            type="text"
            ref="url"
            name="url1"
            placeholder="Url"
            cf-questions="Please drop the GitHub pull request address here."
            cf-error="The address is not valid, use the url like: (https://github.com/project-name/pull/1234)."
            cf-conditional-cfc-intro="1||2||3||4||5"
            required
          />
          {/* 2 PRs */}
          <input
            type="text"
            ref="url"
            name="url2"
            placeholder="Url"
            cf-questions="Pull request 2?"
            cf-error="The address is not valid or you gave it already earlier. Please try again."
            cf-conditional-cfc-intro="2||3||4||5"
            required
          />
          {/* 3 PRs */}
          <input
            type="text"
            ref="url"
            name="url3"
            placeholder="Url"
            cf-questions="Pull request 3?"
            cf-error="The address is not valid you gave it already earlier. Please try again."
            cf-conditional-cfc-intro="3||4||5"
            required
          />
          {/* 4 PRs */}
          <input
            type="text"
            ref="url"
            name="url4"
            placeholder="Url"
            cf-questions="Pull request 4?"
            cf-error="The address is not valid you gave it already earlier. Please try again."
            cf-conditional-cfc-intro="4||5"
            required
          />
          {/* 5 PRs */}
          <input
            type="text"
            ref="url"
            name="url5"
            placeholder="Url"
            cf-questions="Pull request 5?"
            cf-error="The address is not valid you gave it already earlier. Please try again."
            cf-conditional-cfc-intro="5"
            required
          />
          <button type="submit">Submit</button>
        </div>
      </div>
    );
  }
}

export default ConversationForm;
